import { useSearchParams } from "react-router-dom";

import { MVPOrderSummaryPage } from "./MVP-order-summary-page";
import { SecureVerifyPage } from "./secure-verify-page";

export function SecurePage() {
  const [searchParams] = useSearchParams();
  const shouldShowVerifyPage = searchParams.get("verify") === "true";

  if (shouldShowVerifyPage) {
    console.log("shouldShowVerifyPage", shouldShowVerifyPage);
    return <SecureVerifyPage />;
  }

  return <MVPOrderSummaryPage />;
}
